"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The enum used for increase or decrease font size
 * Used by setFontSize API
 */
var FontSizeChange;
(function (FontSizeChange) {
    /**
     * Increase font size
     */
    FontSizeChange[FontSizeChange["Increase"] = 0] = "Increase";
    /**
     * Decrease font size
     */
    FontSizeChange[FontSizeChange["Decrease"] = 1] = "Decrease";
})(FontSizeChange = exports.FontSizeChange || (exports.FontSizeChange = {}));
//# sourceMappingURL=FontSizeChange.js.map